import * as React from "react"
import type { SVGProps } from "react"
const SvgFilter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11 20.86a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71v-6l-5.8-7.4q-.38-.51-.11-1.05c.27-.54.48-.55.91-.55h14q.65 0 .91.55.27.54-.11 1.05l-5.8 7.4v6q0 .42-.29.71a1 1 0 0 1-.71.29zm1-7.7 4.95-6.3h-9.9z" />
  </svg>
)
export default SvgFilter
